import { createSlice } from "@reduxjs/toolkit";
import { signInMember, signOutMember } from "./memberSlice";

const alertInitialState = {
  state: false,
  type: "success",
  message: "",
};

export const alertSlice = createSlice({
  name: "alert",
  initialState: alertInitialState,
  reducers: {
    alert: (state, { payload }) => {
      state.state = true;
      state.type = payload.type;
      state.message = payload.message;
    },

    closeAlert: (state) => {
      state.state = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(signInMember.rejected, (state) => {
        state.state = true;
        state.type = "error";
        state.message = "Your session has expired!";
      })
      .addCase(signOutMember.fulfilled, (state) => {
        state.state = true;
        state.type = "info";
        state.message = "You have been logged out!";
      });
  },
});

export const { alert, closeAlert } = alertSlice.actions;

export default alertSlice.reducer;
